import { toast } from 'react-toastify';
import api from './api-instance';
import { TUser } from '../types/user';
import { AxiosDataReturn } from '../types/generic';

export const loginUser = async (data: { email: string; password: string }) => {
  try {
    const res = await api.post<AxiosDataReturn<{ user: TUser }>>(
      `/auth/admin/signin`,
      data
    );
    return res.data;
  } catch (e) {
    toast.error('Invalid Email Or Password', { toastId: 'login-error' });
    throw e;
  }
};

export const getLoggedInUserDetails = async () => {
  try {
    const res = await api.get<AxiosDataReturn<TUser>>(`/auth/admin`);
    return res.data.data;
  } catch (e) {
    toast.error('Server Error', { toastId: 'api-error' });
    throw e;
  }
};
